import CreateTask from '@plugin/task/views/CreateTask';
import CreateProduct from '@plugin/products/views/CreateProduct';
import CreateCustomer from '@plugin/customer/views/CreateCustomer';
import CreateLead from '@plugin/leads/views/CreateLead';
import CreateCategory from '@plugin/categories/views/CreateCategory';
import CreateModule from '@plugin/modules/views/CreateModule';
import CreateUser from '@plugin/users/views/CreateUser';
import CreateReceipt from '@plugin/Finance/Receipts/views/CreateReceipt';
import PartialPaymentDialog from '@plugin/Finance/Receipts/views/PartialPaymentDialog';
import LeadSidebar from '@plugin/leads/views/LeadSidebar';
import Notes from '@components/notes/Notes';
import Mail from '@plugin/mail/Mail';
import CustomLayoutBuilder from '@plugin/customFieldsBuilder/views/CustomLayoutBuilder';

// Stores
import { useTaskCreateStore } from '@plugin/task/store/useTaskCreateStore';
import { useProductCreateStore } from '@plugin/products/store/useProductCreateStore';
import { useCustomerCreateStore } from '@plugin/customer/store/useCustomerCreateStore';
import { useCategoryCreateStore } from '@plugin/categories/store/useCategoryCreateStore';
import { useModuleCreateStore } from '@plugin/modules/store/useModuleCreateStore';
import { useUsersCreateStore } from '@plugin/users/store/useUsersCreateStore';
import { useLeadCreateStore } from '@plugin/leads/store/useLeadCreateStore';
import { useEmailCreateStore } from '@plugin/mail/store/useMailStore';
import { useCustomLayoutsStore } from '@plugin/customFieldsBuilder/store/CustomLayoutBuilderStore';
import { useLeadSidebarStore } from '@plugin/leads/store/useLeadSidebarStore';
import { useNotesStore } from '@components/notes/store/useNotesStore';
import { useReceiptCreateStore } from '@plugin/Finance/Receipts/store/useReceiptCreateStore';
import { useReceiptPartialStore } from '@plugin/Finance/Receipts/store/useReceiptPartialStore';

// Core modal/component catalog (key + Component + store)
export const coreModalsConfig = [
  { key: 'modules', Component: CreateModule, store: useModuleCreateStore },
  { key: 'lead', Component: LeadSidebar, store: useLeadSidebarStore },
  { key: 'task', Component: CreateTask, store: useTaskCreateStore },
  { key: 'product', Component: CreateProduct, store: useProductCreateStore },
  { key: 'customer', Component: CreateCustomer, store: useCustomerCreateStore },
  { key: 'users', Component: CreateUser, store: useUsersCreateStore },
  // If you open a separate "create lead" modal by another key, keep it distinct:
  { key: 'leadCreate', Component: CreateLead, store: useLeadCreateStore },
  { key: 'receipt', Component: CreateReceipt, store: useReceiptCreateStore },
  { key: 'receiptLog', Component: PartialPaymentDialog, store: useReceiptPartialStore },
  { key: 'notes', Component: Notes, store: useNotesStore },
  { key: 'category', Component: CreateCategory, store: useCategoryCreateStore },
  { key: 'customLayout', Component: CustomLayoutBuilder, store: useCustomLayoutsStore },
  { key: 'mail', Component: Mail, store: useEmailCreateStore },
];

// Optional: export a core store map (handy for merging with custom)
export const coreStores = coreModalsConfig.reduce((acc, m) => {
  if (m.key && typeof m.store === 'function') acc[m.key] = m.store;
  return acc;
}, {});